export default __webpack_public_path__ + "static/media/cpa.2942db1a.png";